/**
 * Fix header on scroll
 */
export function fixed_header() {
	const header     = document.querySelector( "[data-header-hire]" )
	const wpadminbar = document.querySelector( "#wpadminbar" )

	if ( ! header) {
		return

		window.onscroll = function () {
			if (window.pageYOffset > 0) {
				header.style.position = 'fixed'

				if (wpadminbar !== null) {
					header.style.top = '32'
				} else {
					header.style.top = '0'
				}
			} else {
				header.style.position = 'relative'
			}
		}
	}
}
